import { Text, VStack } from '@chakra-ui/react';
import { Overline } from '@time-line/components/common';
import type { PartnerPage } from 'types/cms/pages/PartnerPage';

import type { AnchorBlock } from '../AnchorCtas';
import { AnchorCtas } from '../AnchorCtas';
import { HeroWrapper } from './HeroWrapper';

interface PartnerHeroProps extends Pick<
  PartnerPage,
  'name' | 'role' | 'quote' | 'overline' | 'image' | 'video' | 'cta'
> {
  anchorBlock?: AnchorBlock;
}

export function PartnerHero({
  image,
  video,
  role,
  name,
  overline,
  quote,
  cta,
  anchorBlock,
}: PartnerHeroProps) {
  const isAnchorCta = cta?.type === 'anchor';
  const showCta = !!anchorBlock && isAnchorCta;

  return (
    <HeroWrapper image={image} video={video} hasCta={showCta}>
      <VStack
        as="blockquote"
        color="white"
        textAlign="center"
        alignItems="center"
        gap={0}
      >
        {overline && <Overline {...overline} mb={{ base: '3xs', md: '2xs' }} />}
        <Text size="h2-serif" as="h1" sx={{ textWrap: 'pretty' }}>
          “{quote}”
        </Text>
        <Text
          mt={{ base: '2xs', md: 'xs' }}
          size="overline"
          as="cite"
          display="block"
        >
          {name}
        </Text>
        <Text size="overline" color="whiteAlpha.700">
          {role}
        </Text>
        {isAnchorCta && (
          <AnchorCtas
            anchorBlock={anchorBlock}
            colorScheme="white"
            maxW="480px"
            mt={{ base: 'sm', md: 'm' }}
          />
        )}
      </VStack>
    </HeroWrapper>
  );
}
